import {
  Box,
  Breadcrumbs,
  Typography,
  Tab,
  Tabs,
  TabsProps,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import { getDocumentTitle } from "@/utils";

export function TrainerListPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const path = location?.pathname ?? "";

  const onChangeTab: TabsProps["onChange"] = (_, value: string) => {
    navigate(value, { replace: true });
  };

  return (
    <Box>
      <Helmet>
        <title>{getDocumentTitle("Trainer")}</title>
      </Helmet>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        sx={{ mb: 2 }}
      >
        <Typography color="text.primary">เทรนเนอร์</Typography>
      </Breadcrumbs>
      <Tabs value={path} onChange={onChangeTab} sx={{ mb: 3 }}>
        <Tab label="รายชื่อเทรนเนอร์" value={"/trainers"} />
        <Tab label="ยืนยันการจอง" value={"/trainers/confirm-bookings"} />
      </Tabs>
      <Outlet />
    </Box>
  );
}
